import { TrackableBy } from "../models/trackable.by";
import BaseService from "./_base.service";

const endpoint = "trackable/by";

const TrackableByService = {
  ...BaseService<TrackableBy>({ endpoint }),
};

export default TrackableByService;
